//@flow
import * as React from 'react';
import { themr } from 'react-css-themr';
import classnames from 'classnames';
import type { BusinessUnit } from 'common/models/internal/BusinessUnits';

import theme from './BusinessUnitChip.scss';

type Props = {
    businessUnit: BusinessUnit,
    className?: string,
    theme: Object,
    disabled?: boolean,
    onSelect: string => void
};

class BusinessUnitChip extends React.PureComponent<Props> {
    handleSelect = () => {
        const {
            businessUnit: { businessUnitId },
            onSelect
        } = this.props;
        onSelect(businessUnitId);
    };
    render() {
        const { businessUnit, className } = this.props;
        const { name, color } = businessUnit;
        return (
            <div
                onClick={this.handleSelect}
                className={classnames(theme.buChipWrap, className)}
            >
                <div className={theme.chipInner} style={{ borderColor: color }}>
                    <span className={theme.label}>{name}</span>
                </div>
            </div>
        );
    }
}

export default themr('BusinessUnitChip', theme)(BusinessUnitChip);
